import { useDispatch } from "react-redux";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import getCurrentUserId from "../../reduxSaga/sagas/requests/currentUserId";
import UtilsFormule from "../../utils/UtilsFormule";
import { Alert } from "@material-ui/lab";
import { Snackbar } from "@mui/material";
import withLoader from "../../components/layouts/WithLoader";
import ShopService from "../../services/PosService/ShopService";

const ShopManagers = ({ startLoading, stopLoading }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [availableShop, setAvailableShop] = useState([]);
  const [userRole, setUserRole] = useState("");

  //alert
  const [openErrorAlert, setOpenErrorAlert] = useState(false);
  const [errorAlertText, setErrorAlertText] = useState();
  const handleEroorClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenErrorAlert(false);
  };

  useEffect(() => {
    if (localStorage.getItem("status") == null) {
      setUserRole(["notConnected"]);
    } else {
      setUserRole(JSON.parse(localStorage.getItem("status")));
    }
    startLoading();
    ShopService.getAllShopByManager(getCurrentUserId())
      .then((response) => {
        if (response.data.success) {
          setAvailableShop(response.data.success);
        } else if (response.data.error) {
          setOpenErrorAlert(true);
          setErrorAlertText("Erreur : " + response.data.error);
        }
      })
      .catch((e) => {
        setOpenErrorAlert(true);
        setErrorAlertText("Erreur : " + e);
        console.log("error in getAllShop", e);
      })
      .finally(() => {
        stopLoading();
      });
  }, []);

  const onVoirTicketsMagasin = (id) => {
    localStorage.setItem("idDetailsTicketMagasin", id);
    window.open("/tickets-magasin", "_blank");
  };
  const onVoirJournauxCaisses = (id) => {
    localStorage.setItem("idShopJournaux", id);
    localStorage.setItem("typeGetJournaux", "shop");
    window.open("/journal-caisse", "_blank");
  };

  const onVoirTraiteMagasin = (id, ref, name) => {
    localStorage.setItem("nameDetailsTicketMagasin", name);

    localStorage.setItem("idDetailsTicketMagasin", id);
    window.open("/traite-magasin", "_blank");
  };
  const onVoirCreditMagasin = (id, ref, name) => {
    localStorage.setItem("nameDetailsTicketMagasin", name);

    localStorage.setItem("idDetailsTicketMagasin", id);
    window.open("/credit-magasin", "_blank");
  };
  return (
    <div className="content-wrapper" style={{ marginTop: "0" }}>
      <div className="content ">
        <div className="container-fluid">
          <div className="row mb-2">
            <div className="col-sm-12">
              <div class="card  mt-3">
                <div class="card-body">
                  <h5 class="card-title">Les magasins</h5>
                </div>
              </div>
              <section class="content">
                <div class="card">
                  <div class="card-header  ">
                    <h3 class="card-title">Les magasins</h3>
                    <div class="card-tools">
                      <button
                        type="button"
                        class="btn btn-tool"
                        data-card-widget="collapse"
                        title="Collapse"
                      >
                        <i class="fas fa-minus"></i>
                      </button>
                    </div>
                  </div>
                  <div class="card-body p-0">
                    <table class="table  projects">
                      <thead>
                        <tr>
                          <th>Libellé</th>
                          <th style={{ width: "12%" }}>DC</th>
                          <th className="text-center" style={{ width: "12%" }}>
                            Les Tickets
                          </th>{" "}

                          <th className="text-center" style={{ width: "12%" }}>
                            Le credit
                          </th>
                          <th className="text-center" style={{ width: "12%" }}>
                            Les traites
                          </th>
                          {userRole.includes("DIRECTEUR_MAGASIN") && (
                            <th
                              className="text-center"
                              style={{ width: "12%" }}
                            >
                              Les journaux
                            </th>
                          )}
                        </tr>
                      </thead>
                      <tbody>
                        {availableShop &&
                          availableShop.map((element, i) => (
                            <tr key={element.id}>
                              <td>
                                {element.ref}-{element.name}
                              </td>

                              <td>
                                {UtilsFormule.formatDate(element.creationDate)}
                              </td>
                              <td className="text-center">
                                <button
                                  style={{ width: 40 }}
                                  class="btn btn-dark btn-sm"
                                  onClick={() =>
                                    onVoirTicketsMagasin(element.id)
                                  }
                                >
                                  <i class="fas fa-ticket"></i>
                                </button>
                              </td>
                              <td className="text-center">
                                <button
                                  style={{ width: 40 }}
                                  class="btn btn-dark btn-sm"
                                  onClick={() =>
                                    onVoirCreditMagasin(element.id, element.ref, element.name)
                                  }
                                >
                                  <i class="fas fa-ticket"></i>
                                </button>
                              </td>
                              <td className="text-center">
                                <button
                                  style={{ width: 40 }}
                                  class="btn btn-dark btn-sm"
                                  onClick={() =>
                                    onVoirTraiteMagasin(element.id, element.ref, element.name)
                                  }
                                >
                                  <i class="fas fa-money-bill"></i>
                                </button>
                              </td>
                              {userRole.includes("DIRECTEUR_MAGASIN") && (
                                <td className="text-center">
                                  <button
                                    style={{ width: 40 }}
                                    class="btn btn-dark btn-sm"
                                    onClick={() =>
                                      onVoirJournauxCaisses(element.id)
                                    }
                                  >
                                    <i class="fas fa-book"></i>
                                  </button>
                                </td>
                              )}
                            </tr>
                          ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              </section>
            </div>
          </div>
        </div>
      </div>
      <Snackbar
        open={openErrorAlert}
        autoHideDuration={2000}
        onClose={handleEroorClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
      >
        <Alert variant="filled" onClose={handleEroorClose} severity="error">
          {errorAlertText}
        </Alert>
      </Snackbar>
    </div>
  );
};
export default withLoader(ShopManagers);
